module.exports = __webpack_public_path__ + "static/media/btn_android_ja.3e047c2a.png";